module.exports = __webpack_public_path__ + "img/ic-manage.6525434d.svg";